import { useId } from 'react'
import { SettingsFieldDescription, SettingsFieldLabel } from '@/components/settings/settings-field-copy'
import { SettingsPanel } from '@/components/settings/settings-panel'
import { SettingsRowFrame } from '@/components/settings/settings-row-frame'
import { SettingsSectionHeading } from '@/components/settings/settings-section-heading'
import { Switch } from '@/components/ui/switch'
import { useSignupPolicy, useUpdateSignupPolicy } from '@/hooks/use-signup-policy'

export function SignupPolicySettings() {
  const switchId = useId()
  const { data, isLoading } = useSignupPolicy()
  const updatePolicy = useUpdateSignupPolicy()

  if (isLoading || data?.mode !== 'approval') {
    return null
  }

  const requireApproval = data.require_approval
  const announced = updatePolicy.isSuccess
    ? requireApproval
      ? 'New signups now require approval'
      : 'New signups no longer require approval'
    : updatePolicy.isError
      ? updatePolicy.error.message
      : ''

  return (
    <SettingsPanel className="mb-6">
      <SettingsSectionHeading isFirst>Signup</SettingsSectionHeading>
      <SettingsRowFrame showDivider={false}>
        <div className="flex items-start justify-between gap-4 py-3">
          <div className="min-w-0">
            <SettingsFieldLabel htmlFor={switchId}>Require approval for new signups</SettingsFieldLabel>
            <SettingsFieldDescription>
              When on, new Talent and Employer accounts wait in Signups until someone
              approves. When off, new accounts can sign in after email verify.
            </SettingsFieldDescription>
          </div>
          <Switch
            id={switchId}
            checked={requireApproval}
            disabled={updatePolicy.isPending}
            onCheckedChange={(checked) => updatePolicy.mutate(checked)}
            aria-label="Require approval for new signups"
          />
        </div>
      </SettingsRowFrame>
      <p className="sr-only" role="status">
        {announced}
      </p>
    </SettingsPanel>
  )
}
